export default __webpack_public_path__ + "static/media/chromaIcon.8c4cdb18.svg";